import React from "react";

import { Grid } from "@material-ui/core";

import PropTypes from "prop-types";
import { KeyValueDisplay } from "../../../components/Typography";

const ReceiptLineItem = ({
  label,
  value,
  isTitle,
  justify,
  labelColor,
  strikeThrough,
  tooltipProps,
}) => (
  <Grid item xs={12}>
    <KeyValueDisplay
      keyTypographyProps={{ variant: isTitle ? "h6" : null }}
      valueTypographyProps={{ variant: isTitle ? "h6" : null }}
      label={label}
      text={value}
      justify={justify}
      separator=""
      labelColor={labelColor}
      textColor={labelColor}
      strikeThrough={strikeThrough}
      {...tooltipProps}
    />
  </Grid>
);

ReceiptLineItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  isTitle: PropTypes.bool,
  justify: PropTypes.string,
  labelColor: PropTypes.string,
  strikeThrough: PropTypes.bool,
  tooltipProps: PropTypes.object,
};

ReceiptLineItem.defaultProps = {
  label: "",
  value: "",
  isTitle: false,
  justify: "space-between",
  labelColor: "initial",
  strikeThrough: false,
  tooltipProps: {},
};

export default ReceiptLineItem;
